import React, {useEffect, useState} from 'react';
import parse from "html-react-parser";

const Privacy = () => {
    const [termsText, setTermsText] = useState("");

    useEffect(() => {
        fetch(`/resources/privacy.html`)
            .then(res => res.text()).then((response)=>{
                setTermsText(response);
            });
    }, []);

    return (
        <div className="lightContent center">
            <div className="fullTextArea">
                <div className="mainTitle spacer spacerUp">Privacy Policy</div>
                <div className="termsContent">{parse(termsText)}</div>
            </div>
        </div>
    );
};

export default Privacy;